import React, { useRef, useEffect, useState, useCallback } from 'react';

export default function TencentCaptcha({
  siteKey,
  onVerify,
}) {
  const containerRef = useRef(null);
  const captchaInstanceRef = useRef(null);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  const initializeCaptcha = useCallback(() => {
    if (window.TencentCaptcha && siteKey && containerRef.current) {
      try {
        // Create new instance if it doesn't exist
        if (!captchaInstanceRef.current) {
          captchaInstanceRef.current = new window.TencentCaptcha(
            containerRef.current,
            siteKey,
            (res) => {
              if (res.ticket && res.randstr) {
                // Tencent Captcha returns ticket as the token
                onVerify(`${res.ticket}|${res.randstr}`);
              } else {
                onVerify(null);
              }
            },
            {},
          );
        }
        captchaInstanceRef.current.show();
      } catch (error) {
        console.error('Tencent Captcha error:', error);
        onVerify(null);
      }
    }
  }, [siteKey, onVerify]);

  // Load script dynamically
  useEffect(() => {
    // Check if script is already loaded
    if (window.TencentCaptcha) {
      setScriptLoaded(true);
      return;
    }

    // Check if script tag already exists
    const existingScript = document.querySelector('script[src="https://ca.turing.captcha.qcloud.com/TJNCaptcha-global.js"]');
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        setScriptLoaded(true);
      });
      return;
    }

    // Create and load script
    const script = document.createElement('script');
    script.src = 'https://ca.turing.captcha.qcloud.com/TJNCaptcha-global.js';
    script.async = true;
    script.onload = () => {
      setScriptLoaded(true);
    };
    script.onerror = () => {
      console.error('Failed to load Tencent Captcha script');
    };
    document.body.appendChild(script);

    // Cleanup
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  // Initialize captcha when script is loaded
  useEffect(() => {
    if (scriptLoaded && siteKey && containerRef.current) {
      // Small delay to ensure container is ready
      setTimeout(initializeCaptcha, 100);
    }
  }, [scriptLoaded, siteKey, initializeCaptcha]);

  return <div ref={containerRef} id="cap_iframe" />;
}

